import { render, staticRenderFns } from "./NoticeChatDialogComponent.vue?vue&type=template&id=5574b7b1&scoped=true"
import script from "./NoticeChatDialogComponent.vue?vue&type=script&lang=js"
export * from "./NoticeChatDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574b7b1",
  null
  
)

export default component.exports